// Shared `?debug=true` query helpers — used by App Shell debug tools and meetings logging.

const DEBUG_QUERY_PARAM = 'debug'

/** `?debug=true` — master gate for App Shell debug panel and other debug consumers. */
export function hasDebugQueryParam(search = '') {
  return new URLSearchParams(search).get(DEBUG_QUERY_PARAM) === 'true'
}

/** True in local development/review (console helpers, localStorage overrides). */
export function isDebugToolsEnv() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'review'
}

/**
 * True when debug overrides may be read or written — local/review, or `?debug=true` anywhere.
 * Does not alone show the navbar panel (that also requires alpha via `useShowDebugToolsPanel`).
 */
export function isDebugToolsActive(
  search = typeof window !== 'undefined' ? window.location.search : '',
) {
  return hasDebugQueryParam(search) || isDebugToolsEnv()
}
